import { cookieUtil } from '@/intl-jdi-common-ssr/utils/cookieUtils';

const CLICK_HISTORY_KEY = 'clickEvent';

export type Click_Event_Type = {
  curClickEvent: string | undefined;
  curPageId: string;
  curClickSpm?: string;
  curClickParam: any;
};

export function fetchClickHistory(): Click_Event_Type[] {
  const sessionVal = cookieUtil.getSessionStorage(CLICK_HISTORY_KEY);

  if (sessionVal) {
    try {
      const clickData: Click_Event_Type[] = JSON.parse(sessionVal);
      if (Array.isArray(clickData)) {
        return clickData;
      }
    } catch (error) {
      return [];
    }
  }
  return [];
}

export function appendClickHistory(event: Click_Event_Type) {
  const list = fetchClickHistory();

  // 页面发生跳转时，记录点击历史
  // curPageId不同则添加
  if (
    list.length === 0 ||
    list[0].curPageId !== event.curPageId ||
    list[0].curClickSpm !== event.curClickSpm
  ) {
    list.unshift(event);
  } else if (list[0]?.curPageId === event.curPageId) {
    // 页面未发生跳转，覆盖原点击记录
    list[0] = event;
  }

  while (list.length > 5) {
    list.pop(); // 移除最后的记录
  }

  cookieUtil.setSessionStorage(CLICK_HISTORY_KEY, JSON.stringify(list));
}

export function fetchSessionPageHistory() {
  const PAGE_HISTORY_KEY = 'pageHistory';
  const sessionVal = cookieUtil.getSessionStorage(PAGE_HISTORY_KEY);

  if (sessionVal) {
    try {
      const historyList: string[] = JSON.parse(sessionVal);
      if (Array.isArray(historyList)) {
        return historyList;
      }
    } catch (error) {
      return [];
    }
  }
  return [];
}
